import { ReviewAvatarEnum } from "gqlTypes/globalTypes";
import facebook from "images/facebook-icon.svg";
import instagram from "images/instagram-icon.svg";
import logo from "images/logo.svg";
import userAvatar0 from "images/reviews/user-avatar-0.svg";
import userAvatar1 from "images/reviews/user-avatar-1.svg";
import userAvatar2 from "images/reviews/user-avatar-2.svg";
import userAvatar3 from "images/reviews/user-avatar-3.svg";
import userAvatar4 from "images/reviews/user-avatar-4.svg";
import userAvatar5 from "images/reviews/user-avatar-5.svg";
import userAvatar6 from "images/reviews/user-avatar-6.svg";
import userAvatar7 from "images/reviews/user-avatar-7.svg";
import userAvatar8 from "images/reviews/user-avatar-8.svg";
import userAvatar9 from "images/reviews/user-avatar-9.svg";
import twitter from "images/twitter-icon.svg";
import youtube from "images/youtube-icon.svg";
import { generatePageUrl } from "./utils";
export var BASE_URL = "/";
export var PRODUCTS_PER_PAGE = 18;
export var REVIEWS_PER_PAGE = 10;
export var REVIEW_AVATARS = new Map([[ReviewAvatarEnum.AVATAR_0, userAvatar0], [ReviewAvatarEnum.AVATAR_1, userAvatar1], // TODO: add avatar
[ReviewAvatarEnum.AVATAR_2, userAvatar2], // TODO: add avatar
[ReviewAvatarEnum.AVATAR_3, userAvatar3], // TODO: add avatar
[ReviewAvatarEnum.AVATAR_4, userAvatar4], // TODO: add avatar
[ReviewAvatarEnum.AVATAR_5, userAvatar5], // TODO: add avatar
[ReviewAvatarEnum.AVATAR_6, userAvatar6], // TODO: add avatar
[ReviewAvatarEnum.AVATAR_7, userAvatar7], // TODO: add avatar
[ReviewAvatarEnum.AVATAR_8, userAvatar8], // TODO: add avatar
[ReviewAvatarEnum.AVATAR_9, userAvatar9]]);
export var SUPPORT_EMAIL = "support@example.com";
export var PROVIDERS = {
  BRAINTREE: {
    label: "Braintree"
  },
  DUMMY: {
    label: "Dummy"
  },
  STRIPE: {
    href: "https://js.stripe.com/v3/",
    label: "Stripe"
  }
};
export var STATIC_PAGES = [{
  label: "About",
  url: generatePageUrl("about")
}];
export var SOCIAL_MEDIA = [{
  ariaLabel: "facebook",
  href: "https://www.facebook.com/mirumeelabs/",
  path: facebook
}, {
  ariaLabel: "instagram",
  href: "https://www.instagram.com/mirumeelabs/",
  path: instagram
}, {
  ariaLabel: "twitter",
  href: "https://twitter.com/getsaleor",
  path: twitter
}, {
  ariaLabel: "youtube",
  href: "https://www.youtube.com/channel/UCg_ptb-U75e7BprLCGS4s1g/videos",
  path: youtube
}];
export var META_DEFAULTS = {
  custom: [],
  description: "Open-source PWA storefront built with Saleor's e-commerce GraphQL API. Written with React and TypeScript.",
  image: "".concat(window.location.origin).concat(logo),
  title: "Demo PWA Storefront – Saleor Commerce",
  type: "website",
  url: window.location.origin
};
export var CheckoutStep;

(function (CheckoutStep) {
  CheckoutStep[CheckoutStep["Address"] = 1] = "Address";
  CheckoutStep[CheckoutStep["Shipping"] = 2] = "Shipping";
  CheckoutStep[CheckoutStep["Payment"] = 3] = "Payment";
  CheckoutStep[CheckoutStep["Review"] = 4] = "Review";
})(CheckoutStep || (CheckoutStep = {}));

export var CHECKOUT_STEPS = [{
  index: 0,
  link: "/checkout/address",
  name: {
    DE: "Adresse",
    EN: "Address",
    PL: "Adres"
  },
  nextActionName: {
    DE: "Weiter zum Versand",
    EN: "Continue to Shipping",
    PL: "Przejdź do dostawy"
  },
  nextStepLink: "/checkout/shipping",
  onlyIfShippingRequired: true,
  step: CheckoutStep.Address
}, {
  index: 1,
  link: "/checkout/shipping",
  name: {
    DE: "Versand",
    EN: "Shipping",
    PL: "Dostawa"
  },
  nextActionName: {
    DE: "Weiter zur Zahlung",
    EN: "Continue to Payment",
    PL: "Przejdź do płatności"
  },
  nextStepLink: "/checkout/payment",
  onlyIfShippingRequired: true,
  step: CheckoutStep.Shipping
}, {
  index: 2,
  link: "/checkout/payment",
  name: {
    DE: "Zahlung",
    EN: "Payment",
    PL: "Płatność"
  },
  nextActionName: {
    DE: "Zahlen",
    EN: "Pay",
    PL: "PRZEJDŹ DALEJ"
  },
  nextStepLink: "/order-finalized",
  onlyIfShippingRequired: false,
  step: CheckoutStep.Payment
}];